import { Injectable } from '@angular/core';

interface User {
  id: string;
  name: string;
  email: string;
  cellPhone: string;
  role: string;
  document: string;
  cpf: string;
  cnpj: string;
}

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private currentUser: User | null = null;

  constructor() {
    // Recupera o usuário do localStorage ao inicializar o serviço
    const storedUser = localStorage.getItem('currentUser');
    if (storedUser) {
      this.currentUser = JSON.parse(storedUser);
    }
  }

  getUser(): User | null {
    return this.currentUser;
  }

  setUser(user: User) {
    this.currentUser = user;
    localStorage.setItem('currentUser', JSON.stringify(user));
  }

  clearUser() {
    this.currentUser = null;
    localStorage.removeItem('currentUser');
  }
} 